import md5 from 'js-md5';

const encryptKey = 'bca45d46fb5c6bf9f5c094705b1103a8';

export default {
  /***
   * 对字段按照ASCLL码从小到大排序，按照key1=value1的格式返回
   * @param data
   * @param key
   * @returns String
   */
  createSign(data, key = encryptKey) {
    if (data) {
      let sortedString = '',
        sortedKeys = Object.keys(data).sort();
      let newdata = {};
      //验证数据是否为空
      if (sortedKeys.length > 0) {
        for (let i = 0; i < sortedKeys.length; i++) {
          let thisKey = sortedKeys[i],
            thisValue = data[thisKey];
          // 为空跳出本次循环
          if (thisValue === '' || thisValue == null || thisValue == undefined) {
            continue;
          }
          if (thisValue === true) thisValue = 1;
          if (thisValue === false) thisValue = 0;
          newdata[thisKey] = thisValue;
        }
      }
      newdata.key = key;
      newdata = this.getParams(newdata);
      // console.log("newdata", newdata)
      return md5(newdata);
    }
  },
  getParams(params) {
    let paramStr = '';
    Object.keys(params)
      .forEach((item) => {
        if (paramStr === '') {
          paramStr = `${item}=${params[item]}`;
        } else {
          paramStr = `${paramStr}&${item}=${params[item]}`;
        }
      });
    return paramStr;
  }
}



// WEBPACK FOOTER //
// ./src/utils/sign.js